import { http } from '@/http'

export default {
  list(params) {
    return http.get('/api/v1/admin/redirect', {params})
  },
  get(id) {
    return http.get(`/api/v1/admin/redirect/${id}`);
  },
  save(payload) {
    return http.post('/api/v1/admin/redirect', payload)
  },
  update(id, payload) {
    return http.put(`/api/v1/admin/redirect/${id}`, payload);
  },
  delete(id) {
    return http.delete(`/api/v1/admin/redirect/${id}`);
  }
}
